import React, { Component } from 'react';
import $ from 'jquery';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import * as convert from 'json-form-data';
import styled from 'styled-components';
import { connect } from 'react-redux';

import imageGraphic from '../../svg/image-graphic.svg';
import InstagramImport from '../Offers/Create/InstagramImport';
import { media } from '../../services/api';
import { updateMedia } from '../../redux/business';
import { ComplexLabel, RemoveImageIcon, ImportImageButton, MediaItem, Line } from "../Common";
import Frame from '../Wrappers/Frame';
import ModalQuestion from '../ModalQuestion';
import { imageFix } from '../../helpers';
import { AnalyticsService } from '../../services/AnalyticsService';

const Container = styled.div`
  width: 500px;
  margin: auto;
  margin-bottom: 30px;
`;

interface Media {
  path: string;
  id: string;
}

const SortableItem = SortableElement(
  ({ value, removeImage, total }: { value: string; removeImage: Function; total: number }) => (
    <MediaItem>
      {total !== 1 && <RemoveImageIcon onClick={() => removeImage()}>×</RemoveImageIcon>}
      <img src={`${imageFix(value)}`} alt="Offer media" />
    </MediaItem>
  )
);

const SortableList = SortableContainer(
  ({ items, removeImage }: { items: Array<Media>; removeImage: Function }) => {
    return (
      <div style={{ overflowX: 'scroll', width: '460px', whiteSpace: 'nowrap' }}>
        {items.map((value, index) => (
          <SortableItem
            key={index}
            index={index}
            value={value.path}
            total={items.length}
            removeImage={() => removeImage(value)}
          />
        ))}
      </div>
    );
  }
);

interface Props {
  items: Array<Media>;
  dispatch: Function;
}

interface State {
  files: Array<Media>;
  showForm: boolean;
  moved: boolean;
  igOpen: boolean;
  toDelete: Media;
}

class ProfileMedia extends Component<Props, State> {
  input: HTMLInputElement | null = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      showForm: false,
      files: props.items,
      moved: false,
      igOpen: false,
      toDelete: { path: '', id: '' },
    };
  }

  onSortEnd = (props: { oldIndex: number; newIndex: number }) => {
    const files = arrayMove(this.state.files, props.oldIndex, props.newIndex);
    this.setState({
      files,
      moved: true,
    });
    this.save();
  };

  showRemove(item: Media) {
    this.setState({ toDelete: item });
    $('#deleteProfileMediaModal').modal('show');
    return;
  }

  async removeImage(item: string) {
    await media.remove({ media: [item] });
    const files = [...this.state.files].filter((i) => i.id !== item);
    this.update(files);
  }

  async save() {
    const data = this.state.files.map((item) => item.id);
    const result: any = await media.sort({ media: data });
    this.props.dispatch(updateMedia(result.data));
    this.setState({ files: result.data });
  }

  async handleNewImages(e: React.ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    const images = e.target.files;
    const data: any = await media.add(convert({ source: 'image', images }));
    const newFiles: Media[] = [...this.state.files, ...data.data];
    this.update(newFiles);
  }

  async addInstagramImages(item: Array<any>) {
    const data: any = await media.add({ source: 'urls', urls: item.map((item) => item.file) });
    const newFiles: Media[] = [...this.state.files, ...data.data];
    this.update(newFiles);
  }

  update(data: Array<Media>) {
    this.props.dispatch(updateMedia(data));
    const newFiles = data;
    this.setState({ files: newFiles });
  }

  render() {
    return (
      <Frame title="Media">
        <ModalQuestion
          id="deleteProfileMediaModal"
          title="Delete this image?"
          leftName="CANCEL"
          rightName="DELETE"
          children={
            <>
              <div>Are you sure you want to delete this image?</div>
              <img src={this.state.toDelete.path} width="200" alt="" />
            </>
          }
          function={() => {
            this.removeImage(this.state.toDelete.id);
            this.setState({ toDelete: { path: '', id: '' } });
          }}
        />
        <Container>
          <div className="row">
            <div className="col-6">
              <img src={imageGraphic} width="200" alt="Add new" style={{ marginLeft: '30px' }} />
            </div>
            <div className="col-6">
              <br />
              <ImportImageButton
                onClick={() => {
                  AnalyticsService.track('Tap Upload from computer - Profile', {});
                  this.input && this.input.click();
                }}
              >
                Upload from Computer
              </ImportImageButton>
              <input
                type="file"
                multiple
                style={{ display: 'none' }}
                onChange={(e) => this.handleNewImages(e)}
                ref={(input) => (this.input = input)}
              />
              <ImportImageButton
                onClick={() => {
                  this.setState({ igOpen: true });
                  AnalyticsService.track('Tap Import from IG - Profile', {});
                }}
              >
                Import from Instagram
              </ImportImageButton>
            </div>
          </div>
          <br />
          <br />
          <SortableList
            items={this.state.files.map(({ path, id }) => ({ path, id }))}
            removeImage={(item: Media) => this.showRemove(item)}
            onSortEnd={this.onSortEnd}
            axis="x"
            distance={1}
            lockAxis="x"
          />
          <br />
          <ComplexLabel first="DRAG TO REORDER" second="" row={true} />
          <InstagramImport
            open={this.state.igOpen}
            returnImage={(item) => this.addInstagramImages(item)}
            close={() => this.setState({ igOpen: false })}
          />
        </Container>

        <Line />
      </Frame>
    );
  }
}

export default connect(null, (dispatch) => ({ dispatch }))(ProfileMedia);
